import { __assign } from 'tslib';
import { useMemo, useCallback } from 'react';
import MD5 from 'crypto-js/md5';
import { useSelectableContext } from './SelectableProvider.js';

var useSelectableOption = function (option) {
    var _a = useSelectableContext(), activeOption = _a.activeOption, handleMouseEvent = _a.handleMouseEvent, highlightSelected = _a.highlightSelected, look = _a.look, multiple = _a.multiple, selectId = _a.selectId, size = _a.size, toggleOptionSelection = _a.toggleOptionSelection;
    var disabled = option.disabled, selected = option.selected, value = option.value;
    var events = useMemo(function () { return ({
        onClick: handleMouseEvent,
        onMouseEnter: handleMouseEvent,
        onMouseLeave: handleMouseEvent,
    }); }, [handleMouseEvent]);
    var toggleSelection = useCallback(function (e) {
        e && e.stopPropagation();
        toggleOptionSelection(option);
    }, [option]);
    var props = __assign({ id: "".concat(selectId, "-").concat(MD5(value)), "data-value": value, role: "option", "aria-disabled": disabled, "data-active": (activeOption === null || activeOption === void 0 ? void 0 : activeOption.value) === value, "aria-selected": selected }, events);
    return {
        highlightSelected: highlightSelected,
        look: look,
        props: props,
        size: size,
        activeOption: activeOption,
        handleMouseEvent: handleMouseEvent,
        multiple: multiple,
        selectId: selectId,
        toggleSelection: toggleSelection,
    };
};

export { useSelectableOption };
//# sourceMappingURL=useSelectableOption.js.map
